import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import {
  appointmentConfirmationMappingMetric,
  appointmentWritebacksMetric,
  APPOINTMENT_WRITEBACKS_PASS_VALUE,
  syncappCountMetric,
  syncappHealthMetric,
  writebackConfirmationMappingMetric,
} from '../../handoff-metrics/metrics/data-sync';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

const shouldSkipDataSync = (ctx: UnifyMetricEvalContext) =>
  !ctx.officeConfigurations?.isIntegrated;

export const dataSyncInstalledMetricDef: UnifyMetricDefinition = {
  id: 'data_sync_installed',
  name: 'Data Sync Installed',
  sectionName: 'Data Sync',
  allowExceptions: true,
  shouldSkip: shouldSkipDataSync,
  criteria: [
    adaptHandoffMetric(syncappCountMetric),
    adaptHandoffMetric(syncappHealthMetric),
  ],
};

export const writebacksMetricDef: UnifyMetricDefinition = {
  id: 'writebacks',
  name: 'Writebacks',
  sectionName: 'Data Sync',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipDataSync(ctx) ||
    (!isCustomizationFeatureEnabled(
      'Online Schedule Appointment Writebacks',
      ctx.features
    ) &&
      !isCustomizationFeatureEnabled('Appt Confirmations - writebacks', ctx.features)),
  criteria: [
    adaptHandoffMetric(appointmentWritebacksMetric(APPOINTMENT_WRITEBACKS_PASS_VALUE)),
    adaptHandoffMetric(writebackConfirmationMappingMetric),
  ],
};

export const statusMappingSetMetricDef: UnifyMetricDefinition = {
  id: 'status_mapping_set',
  name: 'Status Mapping Set',
  sectionName: 'Data Sync',
  allowExceptions: true,
  shouldSkip: shouldSkipDataSync,
  criteria: [adaptHandoffMetric(appointmentConfirmationMappingMetric)],
};
